<template>
  <div class="La0" :style="{
    gridTemplateColumns: ratio
  }">
    <div class="La0_left">
      <slot name="left"/>
    </div>
    <div class="La0_right">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: ['ratio']

}
</script>

<style lang="scss" scoped>
  .La0 {
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
    max-height: calc(100vh - 89px);
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: 100%;
    .La0_left {
      flex: 1 1 auto;
      overflow-y: auto;
      max-height: calc(100vh - 90px);
    }
    .La0_right {
      flex: 1 1 auto;
      overflow-y: auto;
      max-height: calc(100vh - 90px);
    }
  }
</style>
